import React, { useState } from 'react';
import { useSpring, animated, useTrail } from '@react-spring/web';
import { Link } from 'react-router-dom';

import wph_logo from '../assets/img/whp-logo.png';
import whp_logo_dancing from '../assets/img/whp-logo-dancingwashers.svg';
import menuOpen from '../assets/img/menu-open.png';
import menuClose from '../assets/img/menu-close.png';

import icoIG from "../assets/img/whp-ico-ig.png";
import icoTK from "../assets/img/whp-ico-tk.png";
import icoWP from "../assets/img/whp-ico-wp.png";
import icoYT from "../assets/img/ico-youtube.svg";

const Header = () => {
    const [isOpen, setIsOpen] = useState(false);

    const menuProps = useSpring({
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? 'translateY(0)' : 'translateY(-100%)',
        config: { tension: 200, friction: 20 },
    });

    const toggleMenu = () => {
        setIsOpen(prev => !prev);
    };

    const menuLinks = [
        { id: 1, text: 'Home', href: '/' },
        // { id: 2, text: 'Sube tu video', href: '/upload' },
        //{ id: 3, text: 'Galería de baile', href: '/gallery' },
        // { id: 4, text: 'Términos y Condiciones.', href: '/termsConditions' },
        // { id: 5, text: ' Aviso de Privacidad.', href: '/privacyPolicy' },
    ];

    const trail = useTrail(menuLinks.length, {
        opacity: isOpen ? 1 : 0,
        transform: isOpen ? 'translateX(0)' : 'translateX(-20px)',
        config: { tension: 200, friction: 20 },
        delay: isOpen ? 200 : 0, // Ajusta el retraso al abrir
    });

    return (
        <>
            <header>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-4 text-start">
                            <Link to='/' >
                                <img src={whp_logo_dancing} alt="Logo Dancing Washers" />
                            </Link>
                        </div>
                        <div className="col-4 text-center">
                            <Link to='/' >
                                <img src={wph_logo} alt="Logo Whirlpool" />
                            </Link>
                        </div>
                        <div className="col-4 text-end">
                            <button className='btn btn-link' onClick={toggleMenu}  >
                                {isOpen
                                    ?
                                    <img src={menuClose} alt="Cerrar menú" style={{ maxHeight: '15px' }} />
                                    :
                                    <img src={menuOpen} alt="Abrir menú" style={{ maxHeight: '15px' }} />}
                            </button>
                        </div>
                    </div>
                </div>
            </header>

            <animated.div className='menu' style={{
                ...menuProps,
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 1001,
            }}>
                <div className="menu-content">
                    <div className='container'>
                        <div className="row">
                            <div className='col-12'>
                                <ul style={{ listStyleType: 'none', padding: 0 }}>
                                    {trail.map((style, index) => (
                                        <animated.li key={menuLinks[index].id} style={style}>
                                            <Link to={menuLinks[index].href} onClick={(e) => {
                                                toggleMenu();
                                            }}>
                                                {menuLinks[index].text}
                                            </Link>
                                        </animated.li>
                                    ))}
                                </ul>
                            </div>
                            <div className='col-12 text-center mt-5'>
                                <h3>Contáctanos</h3>
                                <ul className='link-social mb-4'>
                                    <li>
                                        <a href='https://api.whatsapp.com/send?phone=528125161867&text=Hola,%20me%20pueden%20informar%20acerca%20de...' target='_blank' rel="noreferrer">
                                            <img src={icoWP} alt='Contáctanos Whatsapp' />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://www.tiktok.com/@whirlpoollatam?lang=es' target='_blank' rel="noreferrer">
                                            <img src={icoTK} alt='Contáctanos Tiktok' />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://www.instagram.com/whirlpoollatam/?hl=en' target='_blank' rel="noreferrer">
                                            <img src={icoIG} alt='Contáctanos Instagram' />
                                        </a>
                                    </li>
                                    <li>
                                        <a href='https://www.youtube.com/user/MXWhirlpool' target='_blank' rel="noreferrer">
                                            <img src={icoYT} alt='Contáctanos Youtube' />
                                        </a>
                                    </li>
                                </ul>
                                <Link to='/termsConditions' onClick={(e) => { toggleMenu(); }} className='d-block'>
                                    Términos y Condiciones
                                </Link>
                                <Link to='/privacyPolicy' onClick={(e) => { toggleMenu(); }} className='d-block'>
                                    Aviso de privacidad
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </animated.div>
        </>
    );
};

export default Header;
